import {store} from "../../../../redux/store";
import {
  IMySongsFiltersArrangementType,
  IMySongsFiltersDifficulty,
  IMySongsFiltersDifficultyCategory, IMySongsFiltersDifficultySubcategory,
  IMySongsFiltersGenre,
  IMySongsFiltersLoadPayload,
  mySongsFiltersSlice
} from "./mySongsFiltersSlice";

export const mySongsFiltersStore = {
  // Setters - things that modify state
  fillWithData: (filters: IMySongsFiltersLoadPayload) => { store.dispatch(mySongsFiltersSlice.actions.loadMySongsFilters(filters)); },
  reset: () => { store.dispatch(mySongsFiltersSlice.actions.clearMySongsFilters()); },
  // Getters
  isLoaded: (): boolean => (mySongsFiltersSlice.selectors.loadedAtSelector(store.getState()) ?? 0) > 0,
  getGenreIds: (): number[] => mySongsFiltersSlice.selectors.genresSelector(store.getState())?.ids ?? [],
  getGenreFromId: (genreId: number): IMySongsFiltersGenre | undefined => mySongsFiltersSlice.selectors.genresSelector(store.getState())?.byId[genreId],
  getDifficultyCategoryIds: (): number[] => mySongsFiltersSlice.selectors.difficultyCategoriesSelector(store.getState())?.ids ?? [],
  getDifficultyCategoryFromId: (difficultyCategoryId: number): IMySongsFiltersDifficultyCategory | undefined => mySongsFiltersSlice.selectors.difficultyCategoriesSelector(store.getState())?.byId[difficultyCategoryId],
  getDifficultySubcategoryFromId: (difficultySubcategoryId: number): IMySongsFiltersDifficultySubcategory | undefined => mySongsFiltersSlice.selectors.difficultySubcategoriesSelector(store.getState())?.byId[difficultySubcategoryId],
  getDifficultyIds: (): number[] => mySongsFiltersSlice.selectors.difficultiesSelector(store.getState())?.map(({id}) => id) ?? [],
  getDifficultyIdsFromDifficultyCategoryId: (difficultyCategoryId: number): number[] => (mySongsFiltersSlice.selectors.difficultiesSelector(store.getState()) ?? []).filter((difficulty) => (difficulty.categoryId === difficultyCategoryId)).map(({id}) => id),
  getDifficultyById: (difficultyId: number): IMySongsFiltersDifficulty | undefined => mySongsFiltersSlice.selectors.difficultiesSelector(store.getState())?.find((difficulty) => difficulty.id === difficultyId),
  getArrangementTypeIds: (): number[] => mySongsFiltersSlice.selectors.arrangementTypesSelector(store.getState())?.ids ?? [],
  getArrangementTypeFromId: (arrangementTypeId: number): IMySongsFiltersArrangementType | undefined => mySongsFiltersSlice.selectors.arrangementTypesSelector(store.getState())?.byId[arrangementTypeId],
  getArrangementTypeTitleFromId: (arrangementTypeId: number): string | undefined => mySongsFiltersStore.getArrangementTypeFromId(arrangementTypeId)?.name,
  isFilterAvailable(filter: "difficulty" | "genre" | "arrangementType"): boolean {
    switch (filter) {
      case "difficulty":
        return mySongsFiltersStore.isLoaded() && mySongsFiltersStore.getDifficultyCategoryIds().length > 1
      case "genre":
        return mySongsFiltersStore.isLoaded() && mySongsFiltersStore.getGenreIds().length > 1
      case "arrangementType":
        return mySongsFiltersStore.isLoaded() && mySongsFiltersStore.getArrangementTypeIds().length > 1
    }
  },
  isFeaturesAvailable: (): boolean => mySongsFiltersStore.isLoaded(),
  isSorterAvailable: (): boolean => mySongsFiltersStore.isLoaded(),
};
